import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

interface ImpactSectionProps {
  onRequestAudit: () => void;
}

const ImpactSection = ({ onRequestAudit }: ImpactSectionProps) => {
  return (
    <section className="py-12 lg:py-24">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left side - TVL */}
          <div className="text-center lg:text-left">
            <p className="text-muted-foreground text-base md:text-lg mb-3">Total clients' pool secured</p>
            <h2 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold mb-2 md:mb-3 tracking-tight">
              $20,000,000+
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl mb-6 md:mb-8">Worth of crypto assets.</p>
            <Button
              size="lg"
              className="btn-primary-filled rounded-full px-8 py-6 text-base glow-red"
              onClick={onRequestAudit}
            >
              Request Audit <ArrowRight className="ml-1 w-4 h-4" />
            </Button>
          </div>

          {/* Right side - Stats */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold mb-4">Audit Stats 2025</h3>
            
            {/* Audits count */}
            <div className="rounded-2xl border border-border bg-[hsl(140,40%,15%)] p-6">
              <span className="text-4xl font-bold text-[hsl(140,70%,45%)]">23</span>
              <p className="text-[hsl(0,0%,65%)] mt-1">Audits</p>
            </div>

            {/* Vulnerabilities Found */}
            <div className="rounded-2xl border border-border bg-card p-6">
              <p className="text-muted-foreground mb-4">Vulnerabilities Found — <span className="font-bold text-foreground">136</span></p>
              <div className="grid grid-cols-3 gap-3">
                <div className="rounded-xl border border-destructive/30 bg-card p-4 text-center">
                  <span className="text-2xl lg:text-3xl font-bold text-destructive">6</span>
                  <p className="text-muted-foreground text-sm mt-1">Critical</p>
                </div>
                <div className="rounded-xl border border-[hsl(30,90%,50%)]/30 bg-card p-4 text-center">
                  <span className="text-2xl lg:text-3xl font-bold text-[hsl(30,90%,50%)]">19</span>
                  <p className="text-muted-foreground text-sm mt-1">High</p>
                </div>
                <div className="rounded-xl border border-[hsl(50,90%,50%)]/30 bg-card p-4 text-center">
                  <span className="text-2xl lg:text-3xl font-bold text-[hsl(50,90%,50%)]">42</span>
                  <p className="text-muted-foreground text-sm mt-1">Medium</p>
                </div>
              </div>
              <div className="flex justify-between items-center mt-4">
                <span className="text-muted-foreground">Lows</span>
                <span className="font-bold">69</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
